import MainNavigationBarAvantgardeImpl from './main-navigation-bar-avantgarde.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * @namespace MainNavigationBarAvantgarde
 * @memberof Mojito.Applications.Sports
 */

/**
 * Avantgarde design style main navigation bar. Renders a search button, an empty middle slot, and
 * a settings button. The middle slot is a stable, persistent target for
 * {@link Mojito.Presentation.Components.Portal|Portal} (see config's `middleSlotId`), so individual
 * pages can show their own content there (for example the home page Feed/Pro switcher) without this
 * component needing to know which page is currently active.
 *
 * @class MainNavigationBarAvantgarde
 * @memberof Mojito.Applications.Sports.MainNavigationBarAvantgarde
 */

export default UIView('MainNavigationBarAvantgarde', MainNavigationBarAvantgardeImpl);
